import { useEffect, useState } from "react";
import "@/react/components/HelpWidget/assets/styles/thinking-card.css";
import { Icon } from "@/react/components/shared/Icon";
import { Typography } from "@/react/components/shared/uikit/Typography";

interface ThinkingCardProps {
  show?: boolean;
  title: string | null;
}

export const ThinkingCard = ({ show = true, title }: ThinkingCardProps) => {
  const [isVisible, setIsVisible] = useState(show);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);
  const [displayTitle, setDisplayTitle] = useState(title || "");

  useEffect(() => {
    if (title) {
      setDisplayTitle(title);
    }
  }, [title]);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      setIsAnimatingOut(false);
      return undefined;
    }

    if (isVisible) {
      setIsAnimatingOut(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        setIsAnimatingOut(false);
      }, 300); // Match animation duration
      return () => clearTimeout(timer);
    }

    return undefined;
  }, [show, isVisible]);

  if (!isVisible) return null;

  return (
    <div className="mx-4 mt-4">
      <div
        id="copilot-thinking-card"
        className={`bg-primary flex items-start gap-1 rounded-2xl border border-[#E4E7EB] px-4 py-3 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] transition-all duration-300 dark:border-[#42464D] ${
          isAnimatingOut ? "animate-slide-out" : "animate-slide-in"
        }`}
      >
        <Icon
          type="20-hw-copilot-thinking-star"
          size={20}
          className="animate-spin-clock-wise"
        />

        <span className="shimmer-text">
          <Typography.LabelSm weight="medium">
            {displayTitle}
          </Typography.LabelSm>
        </span>
      </div>
    </div>
  );
};
